import React from 'react';
import Feature from '../../components/feature/Feature';
import './whatGTP3.css';

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature title="What is eye-tracking technology" text="
Eye-tracking technology monitors and analyzes the movement and focus of a user's eyes, capturing data on where they look and for how long. Utilsing specialised hardware and software, it accurately tracks eye movements, gaze direction, and pupil dilation, providing valuable insights into user behavior, attention, and cognitive processes." />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">The possibilities are beyond your imagination</h1>
      <p>Explore the Library</p>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature title="Eye-tracking cursor" text="Eye- tracking can be used as a supporting input method that does not con￿ict with other AAC switches. It can be easily applied to a computer, tablet or mobile phone using the embedded camera." />
      <Feature title="Word typing" text="Integrating eye-tracking keyboard or a preferred typing modality (i.e. head-controller/joystick/mouse/AAC devices)." />
      <Feature title="Visual-audio display" text="Emotional expression can be conveyed via options such as emojis, stickers, GIFs and animations, which will be dis- played to communication partners along with accompanying audio." />
    </div>
  </div>
);

export default WhatGPT3;